import { AdminTemplateOptions } from '../AdminTemplate/includes/types/Config'
import BaseTemplateUtil from './types'

const BaseTemplate = {
  install: function(vue: any, { store }: Pick<AdminTemplateOptions, 'store'>) {
    const actions: BaseTemplateUtil = {
      loader: {
        open: () => {
          store.commit('AdminTemplate/TOGGLE_GLOBAL_LOADER', true)
        },
        close: () => {
          store.commit('AdminTemplate/TOGGLE_GLOBAL_LOADER', false)
        }
      },
      saveButton: {
        show: (saveButtonCallback?:() => void) => {
          store.dispatch('AdminTemplate/showSaveConfigButton', saveButtonCallback)
        },
        hide: () => {
          store.dispatch('AdminTemplate/hideSaveConfigButton')
        },
        resetSaveButtonCallback: () => {
          store.commit('AdminTemplate/RESET_SAVE_CONFIG_BUTTON_CALLBACK')
        },
      },
      sidebar: {
        reload: () => {
          store.dispatch('AdminTemplate/RELOAD_SIDEBAR_MENU')
        }
      },
      drawer: {
        toggleVisible: () => {
          store.commit('AdminTemplate/TOGGLE_DRAWER')
        },
      }
    }

    vue.$baseTemplate = actions
    vue.prototype.$baseTemplate = actions
  }
}

export default BaseTemplate
